<template>
  <div id="loginNoPage">
  </div>
</template>
<script>
  var wordHandshake=null
  export default {
    name: 'loginNoPage',
    created() {
      this.initPostmate()
    },
    methods: {
      initPostmate: function() {
           var handshake = new Postmate.Model({
              login:this.login,
              loginout:this.loginout
          });
          handshake.then(parent => {
              wordHandshake = parent
          });
      },
      //登录
      login: function(data) {
        if(data){
          localStorage.removeItem('isLogin');
          localStorage.removeItem('XTOKEN');
          localStorage.removeItem('CURRENTUSER');

          localStorage.setItem('isLogin', data.isLogin);
          localStorage.setItem('XTOKEN', data.XTOKEN);
          localStorage.setItem('CURRENTUSER', JSON.stringify(data.CURRENTUSER));
          this.CONSTANT.currentUser = data.CURRENTUSER;
          window.open(data.url, '_blank')
        }
      },
      loginout: function(data) {
        localStorage.removeItem("isLogin");
        localStorage.removeItem("XTOKEN");
        localStorage.removeItem("CURRENTUSER");
        wordHandshake.emit('tologin');
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/common/loginNoPage.vue